import PropTypes from 'prop-types';
import React from 'react';

import Analytics from '@app/modules/analytics/index';

export default class Step extends React.PureComponent {
  componentDidMount() {
    this.trackAction(this.props.action);
  }

  trackAction = (action) => {
    if (!action) {
      return;
    }
    Analytics.trackSnowplowEvent({
      category: 'transfer',
      action: action,
    });
  };

  render() {
    const { children } = this.props;
    return children;
  }
}

Step.propTypes = {
  action: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  prevButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  nextButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
};
